import { Link } from "@tanstack/react-router";
import { MapPinOff } from "lucide-react";

import { m } from "../../paraglide/messages.js";
import { AuthLayout } from "../../ui/AuthLayout";
import { buttonClass } from "../../ui/Button";
import { StateIcon } from "../../ui/StateIcon";
import { TextLink } from "../../ui/TextLink";
import { useSession } from "../auth/session";

/** A link that leads nowhere: it says nothing moved, and leads home, or to sign in for whoever is not. */
export function NotFoundPage() {
  const signedIn = useSession().status === "signedIn";
  return (
    <AuthLayout
      title={m.not_found_title()}
      state={<StateIcon icon={MapPinOff} tone="info" />}
      footer={signedIn ? <TextLink to="/help">{m.nav_help()}</TextLink> : undefined}
    >
      <p className="text-sm text-text-muted">{m.not_found_text()}</p>
      <Link to={signedIn ? "/" : "/sign-in"} className={`${buttonClass()} w-full`}>
        {signedIn ? m.not_found_action() : m.not_found_sign_in()}
      </Link>
    </AuthLayout>
  );
}
